import ArticleLayout from '@/components/ArticleLayout';

export default function SafetyPage() {
  return (
    <ArticleLayout
      title="CSSBuy Safety Center"
      description="Essential safety guidelines and tips for using CSSBuy and researching products safely."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Safety', to: '/safety' },
      ]}
      lastUpdated="2026-08-30"
    >
      <div className="bg-accent-50 border border-accent-200 rounded-xl p-5 md:p-6 mb-8">
        <h3 className="text-sm font-bold text-accent-800 uppercase tracking-wider mb-2">
          IMPORTANT SAFETY NOTICE
        </h3>
        <p className="text-sm text-accent-700">
          This is an independent informational website. It is not the official CSSBuy website. We do not process payments, orders, refunds or shipping. Always verify information directly with CSSBuy before making any decisions.
        </p>
      </div>

      <h2>Verify URLs Before Clicking</h2>
      <p>
        Always check that you are visiting the official CSSBuy website before entering any login credentials or personal information. Scammers may create fake websites that look similar to the official site. Look for HTTPS and the correct domain name.
      </p>

      <h2>Verify Sellers Carefully</h2>
      <p>
        Before purchasing from any seller, research their reputation. Look for reviews, transaction history, and community feedback. Be cautious with sellers who have little to no history or negative feedback.
      </p>

      <h2>Check Current Prices</h2>
      <p>
        Prices on third-party spreadsheets or guides may not be current. Always verify the current price directly with the seller or on the official platform before placing an order.
      </p>

      <h2>Understand QC (Quality Control)</h2>
      <p>
        QC photos are taken before items are shipped from the warehouse. Review QC photos carefully before approving your shipment. Once you approve, changes may be difficult or impossible.
      </p>

      <h2>Understand Shipping</h2>
      <p>
        Shipping costs depend on weight, volume, destination, and shipping line. Be aware of customs regulations in your country. Some items may be restricted or require additional fees.
      </p>

      <h2>Avoid Suspicious Payments</h2>
      <p>
        Never send payments outside of the official CSSBuy platform. Do not trust sellers who ask for direct payment through unofficial channels. Use the platform's built-in payment system for protection.
      </p>

      <h2>Never Share Your Passwords</h2>
      <p>
        No legitimate service will ask for your password. Do not share your CSSBuy account credentials with anyone, including "customer service" representatives who contact you through unofficial channels.
      </p>

      <h2>Check Customs Rules</h2>
      <p>
        Every country has different customs regulations. Research your local import rules before ordering. Some items may be confiscated, and you may be responsible for import duties and taxes.
      </p>

      <h2>Start with Small Orders</h2>
      <p>
        If you are new to using CSSBuy, start with small, low-value orders to understand the process. This minimizes risk while you learn how the platform works.
      </p>

      <h2>Report Suspicious Activity</h2>
      <p>
        If you encounter suspicious sellers, fake websites, or other potential scams, report them to the official CSSBuy support team and relevant community forums.
      </p>
    </ArticleLayout>
  );
}